<script>
import {apiGetDealList} from "@/api/hm.js";
import vueSeamlessScroll from 'vue-seamless-scroll'
import dayjs from 'dayjs'
export default {
  name: "transaction",
  components: {
    vueSeamlessScroll
  },
  data () {
    return {
      list: [],
      classOption: {
        singleHeight: 30,
        waitTime: 2000
      }
    }
  },
  created() {
    this.getDealList()
  },
  methods: {
    getDealList () {
      const params = {
        pageSize: 100,
        pageNum: 1
      }
      apiGetDealList(params).then(res => {
        this.list = res.data.records
      })
    },
    formatTime (str, format='YYYY-MM-DD') {
      return dayjs(str).format(format)
    }
  }
}
</script>

<template>
<div class="transaction">
  <header>
    <h2>成交动态</h2>
  </header>
  <vue-seamless-scroll :data="list" class="warp" :class-option="classOption">
    <ul>
      <li class="item" v-for="(item, index) in list" :key="index">
        <div class="big-content">
          <div class="name">{{item.rpName}}</div>
          <div class="content-center">
            <div class="location">{{item.deliveryCity}}</div>
            <div class="quantity"><span>{{item.quantity || '-'}}</span>吨</div>
            <div class="text">{{item.buyerCompanyName}}</div>
            <div class="time">{{formatTime(item.time)}}</div>
          </div>
        </div>
      </li>
    </ul>
  </vue-seamless-scroll>
</div>
</template>

<style scoped lang="scss">
.transaction {
  width: 596px;
  background-color: #fff;
  padding: 20px 23px;
  margin-bottom: 6px;
  header {
    h2 {
      font-weight: 800;
      font-size: 18px;
      color: #333333;
      padding-bottom: 28px;
    }
  }
  .warp {
    height: 330px;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    ul {
      list-style: none;
      li {
        height: 30px;
        font-size: 12px;
        color: #666666;
        .big-content{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .name{
            width: 120px;
            text-align: left;
          }
          .content-center{
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .location{
              width: 60px;
              text-align: right;
            }
            .quantity{
              width: 100px;
              text-align: right;
              span{
                color: #61A842;
                margin-right: 3px;
              }
            }
            .text{
              width: 120px;
              text-align: right;
            }
            .time{
              width: 80px;
              text-align: right;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index/transaction.vue